import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetDocumentsByProjectId {
    
    constructor(@inject(ServiceTokens.DocumentRepository) private documentRepository: IDocumentRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<DocumentSummary[]> {
        var documents = await this.documentRepository.getDocuments(groupStoreId, projectId);
        return documents;
        // return {
        //     items: this.organizeDataByFolder(documents)
        // };
    }

    organizeDataByFolder(documents: DocumentSummary[]): Record<string, DocumentSummary[]> {
        const folderMap: Record<string, DocumentSummary[]> = {};
    
          // Sort documents by FolderName (nulls first) and then by Name
        documents.sort((a, b) => {
            if (a.folderName === null && b.folderName === null) {
                return 0;
            } else if (a.folderName === null) {
                return -1;
            } else if (b.folderName === null) {
                return 1;
            } else {
                // Compare FolderName first, then by Name
                if (a.folderName < b.folderName) return -1;
                if (a.folderName > b.folderName) return 1;
                // If FolderName is the same, compare by Name
                return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime();
            }
        });

        documents.forEach(doc => {
            if (!folderMap[doc.folderName]) {
                folderMap[doc.folderName] = [];
            }
            folderMap[doc.folderName].push(doc);
        });
    
        return folderMap;
    }
}

export const GetDocumentsByProjectIdToken = Symbol('GetDocumentsByProjectIdToken');    


export interface GroupedDocumentsResult {
    items: Record<string, DocumentSummary[]>;
}
